var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneDynamicIsland(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 3.5C10.3358 3.5 10 3.83579 10 4.25C10 4.66421 10.3358 5 10.75 5H13.25C13.6642 5 14 4.66421 14 4.25C14 3.83579 13.6642 3.5 13.25 3.5H10.75Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75 1C6.67894 1 5 2.67894 5 4.75V19.25C5 21.3211 6.67894 23 8.75 23H15.25C17.3211 23 19 21.3211 19 19.25V4.75C19 2.67894 17.3211 1 15.25 1H8.75ZM6.5 4.75C6.5 3.50736 7.50736 2.5 8.75 2.5H15.25C16.4927 2.5 17.5 3.50736 17.5 4.75V19.25C17.5 20.4927 16.4927 21.5 15.25 21.5H8.75C7.50736 21.5 6.5 20.4927 6.5 19.25V4.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneDynamicIsland);
export default __webpack_public_path__ + "static/media/phone-dynamic-island.488b079a4df6ab1c78cc59f72a7944a2.svg";
export { ForwardRef as ReactComponent };